export const DEFAULT_FILTERS = {
  waterbody: 1,
};
